import HRMModal from './HRMModal'

var HRM = new HRMModal()
export default HRM
